import React, { useCallback, useState } from "react";
import Select from "react-select";
import styles from "./styles.module.scss";
import globalColors from "../../../_metronic/_assets/sass/custom/globalColors.scss";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { borders } from "../../../_metronic/_assets/sass/custom/globalStyles";
import {
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select as SelectReact,
  TextField,
} from "@mui/material";
const InputForm = ({
  type = "text",
  name,
  placeholder,
  onChange,
  value,
  label,
  error,
  role,
  isSelect,
  options,
  isDisabled,
  defaultValue,
  isMulti,
  isSearchable,
  onKeyDown,
  isRequired,
  height,
  isClearable = true,
  withoutTextTransform = false,
  isSelectV2,
  maxWidth,
  searchPlaceholder = "Buscar documento...",
}) => {
  const selectStyle = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "var(--xv-background, inherit)",
      color: "var(--xv-foreground, inherit)",
      width: "100%",
      border: "none",
      boxShadow: "none",
      outline: "none",
      padding: "0",
      "&:hover": {
        borderColor: "none",
      },
      //minHeight: "480px",
      cursor: "pointer",
      height: height || "var(--xv-control-height, 48px)",
    }),
    container: (styles) => ({
      ...styles,
      width: "100%",
      outline: "none",
      border: "none",
      padding: "0",
      cursor: "pointer",
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: "none",
      border: "none",
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      fontSize: "14px",
      fontFamily: "Open Sans",
      fontWeight: 400,
      color: isSelected
        ? "var(--xv-primary-foreground, #fff)"
        : "var(--xv-foreground, #333)",
      backgroundColor: isSelected
        ? "var(--xv-primary, #925048)"
        : "var(--xv-card, #fff)",

      "&:hover": {
        backgroundColor: "var(--xv-accent, #efe1dd)",
        color: "var(--xv-accent-foreground, #6e0c0e)",
        cursor: "pointer",
      },
    }),
    singleValue: (styles) => ({
      ...styles,
      fontSize: "14px",
      fontWeight: 400,
      fontFamily: "Open Sans",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      color: "var(--xv-foreground, #333)",
    }),
    placeholder: (styles) => ({
      ...styles,
      width: "90%",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      color: "var(--xv-muted-foreground, #667075)",
    }),
    multiValue: (styles, data) => ({
      ...styles,
      backgroundColor: "#F9F7F6",
      color: globalColors.textColor2,
      borderRadius: "4px",
      padding: "4px",
      fontSize: "14px",
      alignItems: "center",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      height: "10%",
      color: globalColors.backgroundColor2,
      ":hover": {
        backgroundColor: globalColors.backgroundColor1,
        color: globalColors.textColor2,
      },
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 101,
      overflowY: "auto",
      backgroundColor: "var(--xv-card, #fff)",
      border: "1px solid var(--xv-border, #ddd)",
      boxShadow: "var(--xv-shadow-md, 0 8px 20px rgba(0,0,0,.12))",
    }),
    menuList: (styles) => ({
      ...styles,
      maxHeight: "240px",
      overflowY: "auto",
      backgroundColor: "var(--xv-card, #fff)",
    }),
  };

  const formartLabel = (label, isRequired) => {
    if (typeof label === "string" && !label.includes("*") && !isRequired)
      return [label, null];

    if (isRequired) {
      return [
        label,
        <span
          style={{
            color: `${
              isDisabled
                ? `${globalColors.primaryColor6}`
                : globalColors.textColor2
            }`,
          }}
        >
          *
        </span>,
      ];
    } else if (typeof label === "string") {
      return [
        label.substring(0, label.length - 1),
        <span
          style={{
            color: `${
              isDisabled
                ? `${globalColors.primaryColor6}`
                : globalColors.textColor2
            }`,
          }}
        >
          {label.substring(label.length - 1)}
        </span>,
      ];
    } else {
      return [label, null];
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [selectSearch, setSelectSearch] = useState("");

  const normalizeSearchText = (text) =>
    String(text || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const visibleOptions = isSearchable
    ? (options || []).filter((option) =>
        normalizeSearchText(option.label).includes(
          normalizeSearchText(selectSearch)
        )
      )
    : options || [];

  const renderEyeIcon = useCallback(
    (show) => {
      return show ? (
        <span onClick={() => setShowPassword(!showPassword)}>
          <AiOutlineEye />
        </span>
      ) : (
        <span onClick={() => setShowPassword(!showPassword)}>
          <AiOutlineEyeInvisible />
        </span>
      );
    },
    [showPassword]
  );

  const handleSpaceFirstChar = (value, callBack) => {
    const spaceFirst = /^( )/.test(value);

    if (spaceFirst) return;

    return callBack(value, name);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: maxWidth ?? "31.5em",
        maxWidth: "calc(100vw - 32px)",
      },
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    getContentAnchorEl: null,
  };

  return (
    <div className={`${styles.inputContainer} `}>
      {isSelect ? (
        <div
          className={`
          ${styles.divInput} ${isDisabled ? styles.isDisabled : ""} `}
          role={role}
        >
          <label
            htmlFor={name}
            style={{
              display: label ? undefined : "none",
              color: `${
                isDisabled
                  ? `${globalColors.primaryColor6}`
                  : globalColors.textColor2
              }`,
              padding: "0 5px",
              backgroundColor: globalColors.colorWhite,
              textWrap: "nowrap",
            }}
          >
            {formartLabel(label)[0]}
            <span
              style={{
                color: `${
                  isDisabled
                    ? `${globalColors.primaryColor6}`
                    : globalColors.textColor2
                }`,
              }}
            >
              {formartLabel(label)[1]}
            </span>
          </label>
          <Select
            isClearable={isClearable}
            isDisabled={isDisabled}
            styles={{
              ...selectStyle,
              border: error ? borders.error : borders.defaultInput,
            }}
            style={{
              height: height ? height : "48px",
              color: isDisabled ? "#b8b8b8" : globalColors.textColor2,
            }}
            maxMenuHeight={200}
            options={options}
            placeholder={placeholder}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            isMulti={isMulti}
            name={name}
            onKeyDown={onKeyDown}
            isSearchable={isSearchable}
            noOptionsMessage={({ value }) =>
              !value && "Resultados não encontrados"
            }
          />
        </div>
      ) : isSelectV2 ? (
        <FormControl
          sx={{
            width: "100%",
            maxWidth: maxWidth ?? "31.5em",
            height: height || "var(--xv-control-height, 48px)",
          }}
        >
          <InputLabel
            htmlFor="outlined-static"
            shrink
            style={{
              fontSize: "18px",
              background: "var(--xv-card, #fff)",
              padding: "0 5px",
            }}
          >
            {label || "Documento *"}
          </InputLabel>
          <SelectReact
            multiple={Boolean(isMulti)}
            displayEmpty
            value={isMulti ? value || [] : value?.value || value || ""}
            onChange={(e) => {
              if (isMulti) {
                onChange(e.target.value);
                return;
              }

              onChange(
                (options || []).find(
                  (option) => option.value === e.target.value
                ) || null
              );
            }}
            onClose={() => setSelectSearch("")}
            label="Documento"
            input={
              <OutlinedInput
                label={label || "Documento *"}
                name="outlined-static"
                id="outlined-static"
              />
            }
            MenuProps={MenuProps}
            renderValue={(selected) => {
              const selectionIsEmpty = isMulti
                ? !Array.isArray(selected) || selected.length === 0
                : selected === "" || selected == null;

              if (selectionIsEmpty) {
                return (
                  <em
                    style={{
                      fontStyle: "normal",
                      color: "#6b6b6b",
                    }}
                  >
                    {placeholder || "Selecione os documentos"}
                  </em>
                );
              }

              const mapLabelOptions = (options || []).reduce((acc, option) => {
                acc[option.value] = option.label;
                return acc;
              }, {});

              if (!isMulti) {
                return mapLabelOptions[selected] || "";
              }

              const mappedValue = selected.map((item) => mapLabelOptions[item]);

              return mappedValue.join(", ");
            }}
          >
            {isSearchable && (
              <ListSubheader
                style={{
                  padding: "8px",
                  backgroundColor: "var(--xv-card, #fff)",
                }}
              >
                <TextField
                  autoFocus
                  fullWidth
                  size="small"
                  placeholder={searchPlaceholder}
                  value={selectSearch}
                  onChange={(event) => setSelectSearch(event.target.value)}
                  onKeyDown={(event) => event.stopPropagation()}
                  inputProps={{ "aria-label": "Buscar documento" }}
                />
              </ListSubheader>
            )}
            {visibleOptions.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
                style={{
                  width: "100%",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {option.label}
              </MenuItem>
            ))}
            {visibleOptions.length === 0 && (
              <MenuItem disabled>Nenhum documento encontrado</MenuItem>
            )}
          </SelectReact>
        </FormControl>
      ) : (
        <div
          className={`${styles.divInput} ${
            isDisabled ? styles.isDisabled : ""
          }`}
          role={role}
          style={
            {
              // border: error ? borders.error : borders.defaultInput,
            }
          }
        >
          <label
            htmlFor={name}
            style={{
              display: label ? undefined : "none",
              color: `${
                isDisabled
                  ? `${globalColors.primaryColor6}`
                  : globalColors.textColor2
              }`,
              padding: "0 5px",
              fontWeight: 400,
              textWrap: "nowrap",
            }}
          >
            {formartLabel(label)[0]}
            <span>{formartLabel(label)[1]}</span>
          </label>
          <input
            id={name}
            type={
              type !== "password" ? type : showPassword ? "text" : "password"
            }
            placeholder={placeholder}
            value={value}
            onChange={({ target: { name, value } }) =>
              handleSpaceFirstChar(value, () => onChange(value, name))
            }
            role={error}
            className={styles.input}
            disabled={isDisabled}
            autoComplete="off"
            name={name}
            style={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
              display: "block",
              height: height ? height : "48px",
              letterSpacing:
                !showPassword && label?.includes("Senha") && value !== ""
                  ? "4px"
                  : "0",
              color: isDisabled ? "#b8b8b8" : globalColors.textColor2,
              textTransform: withoutTextTransform ? "none" : "uppercase",
              // border: isDisabled ? "#b8b8b8" : globalColors.textColor2,
            }}
          />

          {label.includes("Senha") && (
            <span className={styles.eyeIcon}>
              {renderEyeIcon(showPassword)}
            </span>
          )}
        </div>
      )}
      {error && <span className={styles.textError}>{error}</span>}
    </div>
  );
};

export default InputForm;
